import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { validarFechaMomentEnFormatoString, validarCampoString } from '../../funciones_globales/utils';

class FormVen14  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaDesde: null,
            fechaHasta: null,
            estado: '',
        };
        
        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.generarReporteDevolucionesElectPorEstado = this.generarReporteDevolucionesElectPorEstado.bind(this);
    }
    
    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0414')         
        .then(() => {
            let fechaHasta = moment(this.props.fechaProceso, "DD/MM/YYYY");
            let fechaDesde = fechaHasta.subtract(31, 'days');
            this.setState({ fechaDesde,
                            fechaHasta: moment(this.props.fechaProceso, "DD/MM/YYYY")                            
                        });
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0414');
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    generarReporteDevolucionesElectPorEstado(){        
        try {

            let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
            if (!validarFechaMomentEnFormatoString(fechaDesde)){
                alert('La fecha Desde es inválida.');
                return;
            }
            
            let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
            if (!validarFechaMomentEnFormatoString(fechaHasta)){
                alert('La fecha Hasta es inválida.');
                return;
            }

            if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){        
                alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
                return;
            }

            if (!validarCampoString(this.state.estado, 1, 2)){
                alert(`No ha seleccionado el estado que desea consultar.`);
                return;
            }

            let urlReportWithParams =`&rpt=54&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}`;
            urlReportWithParams += `&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}&param3=${this.state.estado}`;
            
            visualizarReporteEnPdf(urlReportWithParams);
        } catch (error) {
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    limpiar(){
        let fechaHasta = moment(this.props.fechaProceso, "DD/MM/YYYY");
        let fechaDesde = fechaHasta.subtract(31, 'days');
        this.setState({ fechaDesde: fechaDesde,
                        fechaHasta: moment(this.props.fechaProceso, "DD/MM/YYYY"),
                        estado: ''
                    });
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Devoluciones Electrónicas por Estado</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-1' margen_arriba={10}>
                            <LabelForm>Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' margen_arriba={10}>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fecha)=>{this.setState({fechaDesde: fecha});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-1' margen_arriba={10}>
                            <LabelForm>Hasta:</LabelForm>                        
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' margen_arriba={10}>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fecha)=>{this.setState({fechaHasta: fecha});}}/>                        
                        </ContainerCol>
                    </Row>         
                    <Row>
                        <ContainerCol className='col-sm-3' margen_arriba={20}>
                            <LabelForm>Pendientes:</LabelForm>
                            <div className='radio'>
                                <LabelForm><input type='radio' name="estado" value="CO" checked={this.state.estado==="CO"} onChange={this.handleInputChange}/>
                                Contraloría</LabelForm>
                            </div>
                            <div className='radio'>
                                <LabelForm><input type="radio" name="estado" value="PC" checked={this.state.estado==="PC"} onChange={this.handleInputChange}/>
                                Comercial</LabelForm>
                            </div>
                            <div className='radio'>
                                <LabelForm><input type="radio" name="estado" value="C" checked={this.state.estado==="C"} onChange={this.handleInputChange}/>
                                Contralor</LabelForm>
                            </div>
                            <div className='radio'>
                                <LabelForm><input type="radio" name="estado" value="G" checked={this.state.estado==="G"} onChange={this.handleInputChange}/>
                                Gerencia</LabelForm>
                            </div>
                            <div className='radio'>
                                <LabelForm><input type="radio" name="estado" value="DE" checked={this.state.estado==="DE"} onChange={this.handleInputChange}/>
                                Por generar</LabelForm>
                            </div>
                        </ContainerCol>
                        <ContainerCol className='col-sm-4' margen_arriba={20}>
                            <LabelForm>Rechazadas:</LabelForm>
                            <div className='radio'>
                                <LabelForm><input type='radio' name="estado" value="RG" checked={this.state.estado==="RG"} onChange={this.handleInputChange}/>
                                Por Gerencia para Contraloría</LabelForm>
                            </div>
                            <div className='radio'>
                                <LabelForm><input type="radio" name="estado" value="RC" checked={this.state.estado==="RC"} onChange={this.handleInputChange}/>
                                Por Contraloría para Comercial</LabelForm>
                            </div>                            
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba={10}>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.generarReporteDevolucionesElectPorEstado}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario
        }
});
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormVen14);